<script setup lang="ts">
import { computed, ref } from "vue";
import type { FeatureCollection } from "geojson";

import { BUTTON_FOCUS_DARK } from "../nuxt/ui-theme";

defineOptions({ inheritAttrs: false });

const props = withDefaults(
  defineProps<{
    center: [number, number];
    zoom?: number;
    mapboxAllowed?: boolean;
    online?: boolean;
    fullscreenTeleportTo?: string;
  }>(),
  { zoom: 12, mapboxAllowed: true, online: true, fullscreenTeleportTo: "body" }
);

const { t } = useI18n();

const browsing = ref(false);

// Seul le point ACTIF d'AppMap porte le pin ; les autres ne sont qu'un cercle.
const CENTER_FEATURE_ID = "browsed-center";

const markers = computed<FeatureCollection>(() => ({
  type: "FeatureCollection",
  features: [{ type: "Feature", properties: { id: CENTER_FEATURE_ID }, geometry: { type: "Point", coordinates: props.center } }],
}));
</script>

<template>
  <UButton
    v-if="mapboxAllowed"
    v-bind="$attrs"
    :label="t('map.fullscreen.browse')"
    trailing-icon="icon:fullscreen"
    color="neutral"
    variant="soft"
    :class="BUTTON_FOCUS_DARK"
    @click="
      () => {
        browsing = true;
      }
    "
  />

  <AppMap
    v-if="browsing"
    v-model:fullscreen="browsing"
    :center="center"
    :zoom="zoom"
    :markers="markers"
    :active-feature-id="CENTER_FEATURE_ID"
    :mapbox-allowed="mapboxAllowed"
    :online="online"
    :fullscreen-teleport-to="fullscreenTeleportTo"
  />
</template>
